// extracted by mini-css-extract-plugin
export default {"MenuContainer":"Nav_MenuContainer__M1Ow8","link":"Nav_link__EL7QY"};